<div class="upsells-container" *transloco="let t">
    @if(sisterUpsells().length && isInItemEditor()) {
        <button 
            class="upsells-header-container button-undecorated"
            [class.bg-white]="!expanded"
            [ngStyle]="{
                'padding': '0rem 0.8rem 0.4rem 1.2rem',
                'cursor': 'default'
            }"
            (click)="scrollToBottom()">
            <div 
                class="header-wrapper"
                id="sister-upsells-heading"
                [ngStyle]="{
                    'cursor': expanded ? 'default' : 'pointer'
                }"
            >
                <cwo-icon
                    [name]="iconNameType.arrow"class="icon"
                    [ngStyle]="{
                    transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)'}"
                />
                <span class="upsells-header sister-upsell-header">{{t("shared_components.sister_upsells.frequently")}}:</span>
            </div>
            <div class="button-container" [ngStyle]="{'display': !expanded ? 'none' : 'flex'}">
                <button [disabled]="!leftButtonVisible" class="button-undecorated arrow-button"
                    style="transform: rotate(90deg);" (click)="arrowButtonClicked('left');"
                    [ariaLabel]="'Show more tabs left'">
                    <cwo-round-icon [iconName]="iconNameType.arrow" class="arrow-icon" />
                </button>
                <button [disabled]="!rightButtonVisible" class="button-undecorated arrow-button"
                    style="transform: rotate(-90deg);" (click)="arrowButtonClicked('right')"
                    [ariaLabel]="'Show more tabs right'">
                    <cwo-round-icon [iconName]="iconNameType.arrow" class="arrow-icon" />
                </button>
            </div>
        </button>
        <div class="upsells-group">
            <div #upsell class="upsells-container" [ngStyle]="{'margin': upsellsMargin()}" (scroll)="setButtonsState()">
                @for (upsellItem of sisterUpsells(); track upsellItem.orderableItem?.item) {
                <cwo-upsell [isInItemEditor]="isInItemEditor()" [triggeringArea]="triggeringArea()" [upsell]="upsellItem" [handleSisterUpsellVisibility]="true" (upsellAdded)="handleUpsellAdded($event)" />
                }
            </div>
        </div>
    } @else {
        @if (upsellItems().length && !isInItemEditor()) {
        <div class="upsells-header-container" [ngStyle]="{'padding': headerPadding()}">
            <span class="upsells-header">{{t("shared_components.checkout_upsells.header")}}</span>
            <div class="button-container">
                <button [disabled]="!leftButtonVisible" class="button-undecorated arrow-button"
                    style="transform: rotate(90deg);" (click)="arrowButtonClicked('left');"
                    [ariaLabel]="'Show more tabs left'">
                    <cwo-round-icon [iconName]="iconNameType.arrow" class="arrow-icon" />
                </button>
                <button [disabled]="!rightButtonVisible" class="button-undecorated arrow-button"
                    style="transform: rotate(-90deg);" (click)="arrowButtonClicked('right')"
                    [ariaLabel]="'Show more tabs right'">
                    <cwo-round-icon [iconName]="iconNameType.arrow" class="arrow-icon" />
                </button>
            </div>
        </div>
        <div class="upsells-group">
            <div #upsell class="upsells-container" [ngStyle]="{'margin': upsellsMargin()}" (scroll)="setButtonsState()">
                @for (upsellItem of upsellItems(); track upsellItem.orderableItem?.item) {
                <cwo-upsell [isInItemEditor]="isInItemEditor()" [triggeringArea]="triggeringArea()" [upsell]="upsellItem" (upsellAdded)="handleUpsellAdded($event)" />
                }
            </div>
        </div>
        }
    }
</div>
